import Innerbannerlines from "@/../../public/images/inner-banner-lines.svg";
import Logoicon from "@/../../public/images/fav-icon.svg";
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { useEffect, useState } from "react";
import { termsApi } from "../service/apis/pages.api";
import { useNavigate } from "react-router-dom";

const TermsScreen = () => {
    const navigate = useNavigate();
    const [responseData, setResponseData] = useState<any>([]);
    const [titleSlug, setTitleSlug] = useState<any>(null);
    const [ , setIsLoading] = useState(false);

    const serviceContents = async() => {
        setIsLoading(true);
        try {
            const response = await termsApi();
            setResponseData(response?.pageData?.pageContent);
            setTitleSlug(response?.pageData);
        } catch (error) {
            console.error("Catch Error: ", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        serviceContents();
    }, []);

    const decodeHtml = (html ="") => {
        const txt = document.createElement('textarea');
        txt.innerHTML = html;
        return txt.value;
    }; 

    const sanitizeData = (htmldata = "") => {
        const sanitizedDescription = decodeHtml(htmldata);
        return (
          <div dangerouslySetInnerHTML={{ __html: sanitizedDescription }}></div>
        );
    };

    return (
        <>
            {/* <HeaderScreen /> */}
            <div className="front-pages privacy-policypage">
                <section className="home-banner innerBanner position-relative common-padd-xl">
                    <div className="homeLine"><img src={Innerbannerlines} alt="line icon" /></div>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="innerBanner-info text-center">
                                    {titleSlug && (
                                        <h1>{titleSlug?.title}</h1>
                                    )}
                                    <div className="breadcrumb-holder text-center">
                                        <Breadcrumb>
                                            <Breadcrumb.Item onClick={() => navigate('/')}><img src={Logoicon} alt="logo icon" /> Home</Breadcrumb.Item>
                                            <Breadcrumb.Item active>{titleSlug?.title}</Breadcrumb.Item>
                                        </Breadcrumb>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="our-services-area common-padd-xl pt-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8 offset-2 mb-3 pvcpage">
                                {responseData[0]?.type === "text" && responseData[0]?.content && (
                                    <h2>{sanitizeData(responseData[0]?.content)}</h2>
                                )}
                                {responseData[1]?.type === "editor" && responseData[1]?.content && (
                                    sanitizeData(responseData[1]?.content)
                                )}
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            {/* <FooterScreen /> */}
        </>
    )
}
export default TermsScreen;